
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const EnergeticasPage = lazy(() => import('../pages/energeticas/page'));
const AbarrotesPage = lazy(() => import('../pages/abarrotes/page'));
const AguaPage = lazy(() => import('../pages/agua/page'));
const GaseosasPage = lazy(() => import('../pages/gaseosas/page'));
const PapelHigienicoPage = lazy(() => import('../pages/papel-higienico/page'));
const IsotonicasPage = lazy(() => import('../pages/isotonicas/page'));
const ProductoDetailPage = lazy(() => import('../pages/producto/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/energeticas',
    element: <EnergeticasPage />
  },
  {
    path: '/abarrotes',
    element: <AbarrotesPage />
  },
  {
    path: '/agua',
    element: <AguaPage />
  },
  {
    path: '/gaseosas',
    element: <GaseosasPage />
  },
  {
    path: '/papel-higienico',
    element: <PapelHigienicoPage />
  },
  {
    path: '/isotonicas',
    element: <IsotonicasPage />
  },
  {
    path: '/producto/:productId',
    element: <ProductoDetailPage />
  },
  {
    path: '*',
    element: <NotFoundPage />
  }
];

export default routes;
